export default "__VITE_ASSET__DWa2WJT0__"